import React from 'react'
import styled from 'styled-components'

import theme from '../components/atoms/theme'

const { animation } = theme

type AnimateTextType = {
  text?: string
  active?: boolean
}

const Word = styled.div`
  display: inline-block;
  overflow: hidden;
`

const InnerWord = styled.div`
  transition: transform ${animation.longLength} ease-in-out;
  transform: translate3d(0, ${(props): number | string => (props.active ? '0%' : '100%')}, 0);

  .sal-animate & {
    transform: translate3d(0, 0, 0);
  }
`

const AnimateText = (props: AnimateTextType): JSX.Element => {
  const { text, active } = props

  const renderLines = (textToSplit: string): JSX.Element[] => {
    const textArray = textToSplit ? textToSplit.split(' ') : []
    const wordOccurrences: { [key: string]: number } = {}

    return textArray.map((word) => {
      // Track how many times this word has appeared
      if (!wordOccurrences[word]) {
        wordOccurrences[word] = 0
      }
      const uniqueKey = `${word}-${wordOccurrences[word]}`
      wordOccurrences[word] += 1

      return (
        <Word key={uniqueKey}>
          <InnerWord active={active}>{word}&nbsp;</InnerWord>
        </Word>
      )
    })
  }

  return <>{renderLines(text)}</>
}

export default AnimateText
